import { FormHelperText as MuiFormHelperText, type FormHelperTextProps as MuiFormHelperTextProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiFormHelperTextProps, 'variant'>>;

export function FormHelperText(props: Props) {
  return <MuiFormHelperText {...props} />;
}

export type { Props as FormHelperTextProps };
